import Main from './views/Main.vue';
import Auth from './views/Auth.vue';
import Registration from './views/Registration.vue';
import RegistrationSuccess from './views/RegistrationSuccess.vue';
import Catalog from './views/Catalog.vue';
import Category from './views/Category.vue';
import Detail from './views/Detail.vue';
import Personal from './views/Personal.vue';
import PersonalNotAuth from './views/PersonalNotAuth.vue';
import Profile from './views/Profile.vue';
import Address from './views/Address.vue';
import AddressDetail from './views/AddressDetail.vue';
import Orders from './views/Orders.vue';
import OrderDetail from './views/OrderDetail.vue';
import Accounts from './views/Accounts.vue';
import PersonalRemove from './views/PersonalRemove.vue';
import Report from './views/Report.vue';
import Basket from './views/Basket.vue';
import Order from './views/Order.vue';
import OrderSuccess from './views/OrderSuccess.vue';
import Notification from './views/Notification.vue';
import Page from './views/Page.vue';
import Notfound from './views/Notfound.vue';

import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'
import store from './store'

// Охранник для неавторизованных пользователей
// Разрешает доступ только если пользователь не авторизован
const ifNotAuthenticated = (to, from, next) => {
    if (typeof store == 'undefined' || store.getters.isAuth !== true) {
        next()
        return
    }
    // Если пользователь авторизован, перенаправляем на главную
    next('/')
}

// Охранник для авторизованных пользователей
// Разрешает доступ только если пользователь авторизован
const ifAuthenticated = (to, from, next) => {
    if (typeof store == 'undefined' || store.getters.isAuth !== false) {
        next()
        return
    }
    // Если пользователь не авторизован, перенаправляем на страницу авторизации
    next('/auth/')
}

const router = createRouter({
    history: createWebHistory(),
    scrollBehavior(to, from, savedPosition) {
        if (to.path === from.path) {
            return false // отключаем скролл
        }
        if (savedPosition) {
            return savedPosition
        } else {
            return { top: 0 }
        }
    },
    routes: [
        {
            path: '/auth/',
            component: Auth,
            name: 'auth',
            meta: {
                layout: 'main',
                name: 'Авторизация',
                requiresAuth: false // Требуется НЕ быть авторизованным
            },
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/registration/',
            component: Registration,
            name: 'registration',
            meta: {
                layout: 'main',
                name: 'Заявка на регистрацию',
                requiresAuth: false // Требуется НЕ быть авторизованным
            },
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/personalnotauth/',
            component: PersonalNotAuth,
            name: 'personalnotauth',
            meta: {
                layout: 'main',
                name: 'Профиль',
                requiresAuth: false // Требуется НЕ быть авторизованным
            },
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/registration_success/',
            component: RegistrationSuccess,
            name: 'registration_success',
            meta: {
                layout: 'main',
                name: 'Спасибо за заявку',
                requiresAuth: false // Требуется НЕ быть авторизованным
            },
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/personal/',
            component: Personal,
            name: 'personal',
            meta: {
                layout: 'main',
                name: 'Профиль',
                requiresAuth: true, show_prev: true
            },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/personal/profile/',
            component: Profile,
            name: 'profile',
            meta: {
                layout: 'main',
                name: 'Личные данные',
                requiresAuth: true, show_prev: true
            },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/personal/address/',
            component: Address,
            name: 'address',
            meta: {
                layout: 'main',
                name: 'Адреса отгрузки',
                requiresAuth: true, show_prev: true
            },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/personal/address/:id/',
            component: AddressDetail,
            name: 'address_detail',
            meta: {
                layout: 'main',
                name: 'Адрес отгрузки',
                requiresAuth: true, show_prev: true
            },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/personal/report/',
            component: Report,
            name: 'report',
            meta: {
                layout: 'main',
                name: 'Взаиморасчеты',
                requiresAuth: true, show_prev: true
            },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/personal/orders/',
            component: Orders,
            name: 'orders',
            meta: {
                layout: 'main',
                name: 'История заказов',
                requiresAuth: true, show_prev: true
            },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/personal/order/:id/',
            component: OrderDetail,
            name: 'orderDetail',
            meta: {
                layout: 'main',
                name: 'Профиль',
                requiresAuth: true, show_prev: true
            },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/personal/accounts/',
            component: Accounts,
            name: 'accounts',
            meta: {
                layout: 'main',
                name: 'Профиль',
                requiresAuth: true, show_prev: true
            },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/personal/remove/',
            component: PersonalRemove,
            name: 'personalRemove',
            meta: {
                layout: 'main',
                name: 'Запрос на удаление',
                requiresAuth: true, show_prev: true
            },
            beforeEnter: ifAuthenticated
        },
        {
            path: '/catalog/',
            component: Catalog,
            name: 'catalog',
            meta: {layout: 'main', name: 'Каталог'}
        },
        {
            path: '/category/:id/',
            component: Category,
            name:'category',
            meta: {layout: 'main', name: 'Каталог', catalog_page: true, show_prev: true, category_page: true},
        },
        {
            path: '/detail/:id/',
            component: Detail,
            name:'detail',
            meta: {layout: 'main', name: '', show_prev: true},
        },
        {
            path: '/basket/',
            component: Basket,
            name: 'basket',
            meta: {layout: 'main', name: 'Корзина', basket_page: true}
        },
        {
            path: '/order/success/',
            component: OrderSuccess,
            name: 'order_success',
            meta: {layout: 'main', name: 'Заказ оформлен'}
        },
        {
            path: '/order/',
            component: Order,
            name: 'order',
            meta: {layout: 'main', name: 'Оформление заказа'}
        },
        {
            path: '/notification/',
            component: Notification,
            name: 'notification',
            meta: {layout: 'main', name: 'Уведомления', show_prev: true}
        },
        {
            path: '/page/:id/',
            component: Page,
            name:'page',
            meta: {layout: 'main', name: '', show_prev: true},
        },
        {
            path: '/',
            component: Main,
            name: 'main',
            meta: {layout: 'main', name: '', main_page: true}
        },
        {
            path: '/:pathMatch(.*)*',
            component: Notfound,
            name: 'notfound',
            meta: {layout: 'main', name: 'Страница 404', show_prev: true}
        },
    ]
})

export default router
